var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg080DownArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.454,115.575c-11.334-11.334-26.404-17.576-42.432-17.576H59.979c-16.029,0-31.097,6.242-42.432,17.576 c-23.397,23.398-23.397,61.466,0,84.862l196.021,196.021c11.695,11.696,27.054,17.544,42.42,17.544 c15.374,0,30.757-5.859,42.474-17.575l128.73-129.299c7.794-7.828,7.766-20.493-0.062-28.287 c-7.829-7.794-20.493-7.766-28.287,0.063l-128.7,129.267c-7.798,7.799-20.488,7.799-28.286,0L45.835,172.15 c-7.8-7.799-7.8-20.488,0-28.287c3.778-3.777,8.801-5.859,14.144-5.859h392.043c5.343,0,10.366,2.081,14.144,5.859 c7.8,7.799,7.8,20.488,0,28.287c-7.811,7.811-7.811,20.475,0,28.287c7.811,7.812,20.476,7.812,28.288,0 C517.85,177.039,517.85,138.971,494.454,115.575z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg080DownArrow2);
export default __webpack_public_path__ + "static/media/080-down-arrow-2.34f3bbb948ead328e3e19bf1df333ad8.svg";
export { ForwardRef as ReactComponent };